import script from "./Filter.vue?vue&type=script&setup=true&lang=js"
export * from "./Filter.vue?vue&type=script&setup=true&lang=js"

import "./Filter.vue?vue&type=style&index=0&id=6e848256&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e848256"]])

export default __exports__